import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { CircularLoader } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { industryTransitionKeys } from "../../utils/i18n";

export const EnrollProgressView = () => {
    const { translate } = useTranslate();

    return (
        <Flex flex="1" alignItems="center" justifyContent="center" padding="32px">
            <Stack
                gap="16px"
                alignItems="center"
                data-automation="industry-transition-impact-report-enrolling"
            >
                <CircularLoader isLarge />

                <Text fontVariant="subtitle1" color={colorsPalettes.carbon[500]}>
                    {translate(industryTransitionKeys.enrollingTitle)}
                </Text>
                <Text fontVariant="body2" color={colorsPalettes.carbon[400]}>
                    {translate(industryTransitionKeys.enrollingHint)}
                </Text>
            </Stack>
        </Flex>
    );
};
